var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userPermissions['edit'])?_c('button',{staticClass:"btn btn-delete border border-dark",on:{"click":function($event){return _vm.clicked($event)}}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2271aa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/permission-buttons/DeleteButton.vue
// module id = 9Ja6
// module chunks = 0